const $ = jQuery.noConflict();

class Slider {
    constructor(selector, args = {}) {
        this.selector = selector;
        this.args = args;
    }

    getDefaultSlickSettings() {
        return {
            dots: false,
            arrows: true,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            pauseOnHover: false,
            speed: 600,
        };
    }

    /**
     * Override our default slick settings with args provided to the class.
     */
    getSlickSettings() {
        return Object.assign({}, this.getDefaultSlickSettings(), this.args);
    }

    init() {
        if (!$(this.selector).not(".slick-initialized").length) {
            return;
        }
        let settings = this.getSlickSettings();
        $(this.selector).slick(settings);
    }
}

const SimpleSlider = new Slider(".gallery-slider__slider");
const TestimonialSlider = new Slider(".testimonial-slider");
const FluidSlider = new Slider(
    ".block-slider-gallery--hard .gallery-slider__slider-fluid",
    {
        centerMode: true,
        variableWidth: true,
    }
);
const CollageSlider = new Slider(
    ".block-image-link-collage__grid",
    {
        centerMode: true,
        variableWidth: true,
        dots: true,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 1199,
                settings: 'unslick',
            },
        ],
    }
);
const FlexibleSlider = new Slider(
    ".block-slider-gallery--flexible .gallery-slider__slider-fluid",
    {
        centerMode: true,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 992,
                settings: {
                    centerMode: false,
                    variableWidth: false,
                },
            },
        ],
    }
);
const NewsLogosSlider = new Slider(
    ".featured-news-logos__logos",
    {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        mobileFirst: true, 
        variableWidth: true,
        responsive: [{
            breakpoint: 991,
            settings: "unslick"
        }],
    }
);
const ImgDescSlider = new Slider(
    ".description-cards__cards",
    {
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [{
            breakpoint: 991,
            settings: "unslick"
        }],
    }
);
const TourHeroSlider = new Slider(".single-tour-hero__slider", {
    variableWidth: true,
});
const TourPopularSlider = new Slider(".block-tabbed-tour-cards__slider", {
    dots: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    variableWidth: true,
    touchThreshold: 100,
    swipeToSlide: true,
});
const FeaturedGuideSlider = new Slider(".block-featured-guide__slider", {
    dots: true,
    arrows: true,
    variableWidth: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [{
        breakpoint: 576,
        settings: {
            slidesToScroll: 1,
            slidesToShow: 1,
            variableWidth: false
        }
    }]
});
const ToursHighlightsSlider = new Slider(".bth-slider", {
    centerMode: true,
    variableWidth: true,
});
const AwardsIconsSlider = new Slider(
    '.icon-awards__icons',
    {
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 991,
                settings: "unslick"
            }
        ]
    }
);
const CircleImageLinksSlider = new Slider(
    '.block-circle-image-links__cards',
    {
        dots: true,
        arrows: false,
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 540,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 991,
                settings: "unslick"
            }
        ]
    }
);
const AwardsLogosSlider = new Slider(
    ".icon-awards__awards",
    {
        dots: false,
        arrows: false,
        infinite: true,
        autoplay: true,
        slidesToScroll: 1,
        mobileFirst: true,
        variableWidth: true,
        responsive: [{
            breakpoint: 991,
            settings: "unslick"
        }],
    }
);

const TourCardsSlider = new Slider(".block-tour-cards__cards", {
    dots: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    arrows: true,
    infinite: true,
    variableWidth: true,
    touchThreshold: 100,
    swipeToSlide: true,
    responsive: [{
        breakpoint: 991,
        settings: {
            centerMode:false,
            slidesToScroll: 1,
            slidesToShow: 2,
        }
    },{
        breakpoint: 1199,
        settings: {
            slidesToScroll: 1,
            slidesToShow: 4,
        }
    }
],
});

export {
    SimpleSlider,
    TestimonialSlider,
    FluidSlider,
    FlexibleSlider,
    TourHeroSlider,
    TourPopularSlider,
    ToursHighlightsSlider,
    NewsLogosSlider,
    AwardsIconsSlider,
    AwardsLogosSlider,
    ImgDescSlider,
    CollageSlider,
    CircleImageLinksSlider,
    FeaturedGuideSlider,
    TourCardsSlider
};
